<template>
    <div class="@px-2 @bg-sfc-black @border @inline-block p3 @border-sfc-black @text-center @rounded-[4px] instantTypography">
        <span class="l1 mobile:!@text-[13px] @text-sfc-white">AT CAPACITY</span>
    </div>
</template>
